<template>
  <div>

    <breadcrumbs></breadcrumbs>

    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      业务员统计
    </div>

    <el-form
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="输入搜索">
        <el-input v-model="keyword" placeholder="请输入关键字"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getchaxu">查询</el-button>
        <el-button @click="gierchozi">重置</el-button>
      </el-form-item>
    </el-form>

    <btns @exec="exec"></btns>

    <div class="adc"></div>

    <div class="getzahi">
      <div v-for="(item, index) in abc" :key="index" @click="getobd(index)">
        <div class="getzahi-a" :class="{ active: index === indelst }">
          {{ item.name }}({{ item.count }})
        </div>
      </div>

      <!-- <div class="getzahi-a" :class="{active : i ===0}">在职人员({{arr.ingCount}})</div> -->

      <!-- <div  class="getzahi-a">离职人员({{arr.outCount}})</div> -->
    </div>

    <div class="adc"></div>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      @selection-change="tableSelectionChange"
    >
      <el-table-column type="selection" width="70"> </el-table-column>

      <el-table-column label="ID" prop="saleId"> </el-table-column>

      <el-table-column label="姓名" prop="saleName"> </el-table-column>

      <el-table-column label="职位" prop="jobName"> </el-table-column>

      <el-table-column label="入职时间" prop="addtime"> </el-table-column>

      <el-table-column v-if="add1" label="离职时间" prop="outtime">
      </el-table-column>

      <el-table-column label="直推回收站数" prop="zhiNum"> </el-table-column>

      <el-table-column label="分配回收站数" prop="fenNum"> </el-table-column>

      <el-table-column label="绑定回收站总数" prop="allNum"> </el-table-column>

      <el-table-column label="操作" prop="name" width="180">
        <template slot-scope="scope">
          <el-link
          v-if="add1==false"
            style="margin: 0 10px"
            type="primary"
            @click="getadd(scope.row.saleId)"
            >编辑</el-link
          >
          <el-link
            style="margin: 0 10px"
            type="primary"
            @click="getckxq(scope.row.saleId)"
            >查看详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <div v-if="paindd">
      <el-pagination
        class="mgt-10 pd-0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searlist.curPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searlist.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <div v-if="paindd1">
      <el-pagination
        class="mgt-10 pd-0"
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="searlist.curPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searlist.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="新增业务员"
      :visible.sync="addORUpdateVisible"
      width="500px"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="姓名">
          <el-input
            v-model="form.saleName"
            placeholder="请输入业务员姓名"
          ></el-input>
        </el-form-item>

        <el-form-item label="性别">
          <el-select v-model="form.sex" placeholder="性别">
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="身份证">
          <el-input
            v-model="form.idcard"
            placeholder="请输入业务员身份证"
          ></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input
            v-model="form.phone"
            placeholder="请输入业务员手机号"
          ></el-input>
        </el-form-item>

        <el-form-item label="联系地址">
          <el-input
            v-model="form.address"
            placeholder="请输入业务员联系地址"
          ></el-input>
        </el-form-item>

        <el-form-item label="入职时间">
          <el-date-picker
            v-model="addtime"
            @change="getfamval"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
          <!-- <el-time-picker
            v-model="form.addtime"
            :picker-options="{
              selectableRange: '18:30:00 - 20:30:00',
            }"
            placeholder="任意时间点"
          >
          </el-time-picker> -->
        </el-form-item>
<!-- 
        <el-form-item label="业务区域">
          <el-cascader
            v-model="form.cityIds"
            :options=" optionProps"
            @change="handleChange"
          ></el-cascader>
        </el-form-item> -->


        <el-form-item label="业务区域" prop="cityDetailId">
        <el-cascader :props="optionProps" v-model="form.cityIds" :options="city" @change="handleChange" clearable></el-cascader>
      </el-form-item>





        <el-form-item label="职位">
          <!-- <el-input v-model="form.jobId" placeholder="请输入职位"></el-input> -->

              <el-select v-model="form.jobId" placeholder="请输入职位">
                 <el-option
                v-for="item in odjobId"
                :key="item.jobId"
                :label="item.jobName"
                :value="item.jobId"
              >
              </el-option>
          </el-select>


        </el-form-item>
      </el-form>

      <div class="shanc">
        <el-button @click.native="addORUpdateVisible = false">取消</el-button>
        <el-button type="primary" @click="getquneding">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import btns from "@/components/btns.vue";

import ExportExcel from '../../utils/ExportExcel.js'

import options from "../../../city.json";
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    btns,
    ExportExcel,
    breadcrumbs,
  },

  data() {
    return {
      odjobId:[],
      regionId:[],
      city:[],
       optionProps: {
        value: 'regionId',
        label: 'regionName',
        children: 'child'
      },
      paindd: true,
      paindd1: false,
     
      addtime:"",

      searlist: {
        curPage: 1,
        pageSize: 10,
      },
      add1: false,
      keyword: "",
      totalCount: 0,
      indelst: 0,
      abc: [],
      arr: "",
      tableSelection:[],
      value1: "",
      form: {
        // name: "",
        // region: "",

        address: "",
        addtime: "",

        cityIds: "",

        idcard: "",

        jobId: "",
        phone: "",

        saleName: "",

        sex: "",
      },

      addORUpdateVisible: false,
      tableData: [{ planCount: "你好" }],
      searchForm: {
        name: "",
      },
    };
  },
  created() {
     this.getAllJobList()
    this.city=options
    this.getSaleCount();
    this.getSaleList(1, this.searlist.curPage, this.searlist.pageSize);
  },
  methods: {


     getAllJobList(){
      
        this.$api.activitymsg
        .getAllJobList({
        
        })
        .then((e) => {
         this.odjobId=e.data
        });
     

     },


    handleChange(value) {
          console.log(value);
          this.form.cityIds=value[2]
    },
      

      daochu(){
       
         this.$api.activitymsg
        .getSaleExcel(
         
         {
           state:"1",
           keyword:this.keyword
         },
       
        )
        .then((res) => {

        let fileName="业务人员.xlsx"
         ExportExcel(res,fileName)
        });
    



      },

//       downloadFile(data) {
// let blob = new Blob([data], {type: 'application/zip'})

// let url = window.URL.createObjectURL(blob)

// const link = document.createElement('a') // 创建a标签

// link.href = url

// link.download = `导出${utils.getTimeString(new Date())}` // 重命名文件

// link.click()

// URL.revokeObjectURL(url) // 释放内存

// },

    
    tableSelectionChange (val) {
    
    console.log(val);
      this.tableSelection = val;

    },


    // 启用

    cing(){

      
       if (this.tableSelection.length != 1) {
        this.$message.error('请选中一行数据');
        return
      }

        let  saleId=this.tableSelection[0].saleId

      this.$api.activitymsg
        .enableSale(
        {
        saleId:saleId,
        state:1,
        }
   
        )
        .then((e) => {

         if (e.code==200) {
                 this.$message({
          message: '启用成功',
          type: 'success'
        });

            this.getSaleCount();
         this.indelst=0
         this.getSaleList(1, this.searlist.curPage, this.searlist.pageSize);
         }else{

           this.$message.error(e.msg);
         }

       
        });




    },

    // 禁用


    jingyong(){

         if (this.tableSelection.length != 1) {
        this.$message.error('请选中一行数据');
        return
      }

        let  saleId=this.tableSelection[0].saleId

      this.$api.activitymsg
        .enableSale(
        {
        saleId:saleId,
        state:2,
        }
   
        )
        .then((e) => {

         if (e.code==200) {
                 this.$message({
          message: '禁用成功',
          type: 'success'
        });
        this.indelst=1
            this.getSaleCount();
         this.getSaleList(2, this.searlist.curPage, this.searlist.pageSize);
         }else{

           this.$message.error(e.msg);
         }

       
        });




    },


 

    getfamval(){
        var date = new Date(this.addtime)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d

       
        var h=date.getHours();
       var mm= date.getMinutes()
       var s=  date.getSeconds()

      this.form.addtime =  y + '-' + m + '-' + d+' '+h+':'+mm+':'+s
     
     console.log(this.form.addtime );
  
    },



   getquneding(){
         

      this.$api.activitymsg
        .addSale(

          this.form
        )
        .then((e) => {

         if (e.code==200) {
                 this.$message({
          message: '操作成功',
          type: 'success'
        });
       this.addORUpdateVisible=false
          this.form={}


          this.getSaleCount()
         this.getSaleList(1, this.searlist.curPage, this.searlist.pageSize);
         }else{

           this.$message.error(e.msg);
         }

       
        });
    



   },






    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },

    add() {
      this.addORUpdateVisible = true;
      console.log("123");
    },

    handleSizeChange(v) {
      this.searlist.pageSize = v;
      this.getCheckList(1, this.searlist.curPage, v);
    },
    handleCurrentChange(v) {
      this.searlist.curPage = v;

      this.getCheckList(1, v, this.searlist.pageSize);
    },

    handleSizeChange1(v) {
      this.searlist.pageSize = v;
      this.getCheckList(2, this.searlist.curPage, v);
    },
    handleCurrentChange1(v) {
      this.searlist.curPage = v;

      this.getCheckList(2, v, this.searlist.pageSize);
    },

    getSaleList(id, curr, pagesize) {
      this.$api.activitymsg
        .getSaleList({
          current: curr,
          size: pagesize,
          state: id,
          keyword: this.keyword,
        })
        .then((e) => {
          this.tableData = e.data;

          this.totalCount = e.totalCount;
        });
    },

    getchaxu() {
      if (this.indelst == 0) {
        this.getSaleList(1, this.searlist.curPage, this.searlist.pageSize);
      } else {
        this.getSaleList(2, this.searlist.curPage, this.searlist.pageSize);
      }
    },
    gierchozi() {
      (this.keyword = ""),
        this.getSaleList(1, this.searlist.curPage, this.searlist.pageSize);
    },

    getobd(index) {
      this.indelst = index;
      if (index == 0) {
        this.getSaleList(1, this.searlist.curPage, this.searlist.pageSize);
        this.add1 = false;

        (this.paindd = true), (this.paindd1 = false);
      } else {
        this.getSaleList(2, this.searlist.curPage, this.searlist.pageSize);
        this.add1 = true;

        (this.paindd = false), (this.paindd1 = true);
      }
    },

    getSaleCount() {
      this.$api.activitymsg.getSaleCount({}).then((e) => {
        this.abc = e.data;
      });
    },

    getckxq(id) {
      // this.$router.push("/index/ordass");


         this.$router.push({
          path: '/index/ordass',
          query: {
            id: id,
            ob:1
          }
        })




    },

    getadd(id) {

    
         this.$router.push({
          path: '/index/ordass',
          query: {
            id: id,
            ob:2
          }
        })





    },
  },
};
</script>

<style scoped>
.active {
  background: var(--accent);
  color: #ffffff;
}

.shanc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.adc {
  height: 20px;
}

.getzahi {
  display: flex;
}

.getzahi-a {
  width: 120px;
  height: 50px;
  display: flex;
  border: solid 1px var(--input-border);
  justify-content: center;
  align-items: center;
}
</style>